
import BlogPostSectionHeadline from '~/components/blog/BlogPostSectionHeadline.vue';
import BlogPostSubtitle from '~/components/blog/BlogPostSubtitle.vue';
import BlogPostTextBlock from '~/components/blog/BlogPostTextBlock.vue';
import BlogPostPage from '~/components/page-components/blogpage/BlogPostPage.vue';
import bloginfo from '~/helpers/bloginfo.js';
import communityinfo from '~/helpers/communityinfo.js';

export default {
  components: { BlogPostPage, BlogPostTextBlock, BlogPostSubtitle, BlogPostSectionHeadline },
  data () {
    return {
      b: bloginfo[3],
      p: communityinfo[3],
      b1: bloginfo[0],
      b2: bloginfo[1]
    };
  }

};
